export const version = '251202'; //YYMMDD 
